import React, { Component, useEffect, useState } from 'react'
import moment from 'moment'
// import axios from 'axios'
// import {generateTempArray} from '../../utilities/common-helpers'
// import { ProductGroupWithCarousel } from '../../components/partials/product/ProductGroupWithCarousel';


// import ShopItems from '../../components/partials/shop/ShopItems';

const Link = require("react-router-dom").Link

const ProductVariantOptionsTable = ({userCredentials, title}) => {
  // const [productItems, setProductItems] = useState([]);
  // const [loading, setLoading] = useState(true);

  const [variant_options, setVariant_ptions] = useState([]);




  async function getVariantOptions() {
    const res = await fetch(`${process.env.REACT_APP_API_URL}v_o/all/true`);
    const variantOptionsArray = await res.json();
    console.log (variantOptionsArray)
    setVariant_ptions(variantOptionsArray);
  }

  useEffect(() => {
    getVariantOptions();
  }, []);


  function handleChangeTab(e, tab) {
    e.preventDefault();
    // setCurrentCollection(tab.name);

  }

  function handleSubmit(e) {
    // e.preventDefault()
    console.log ("navigating")

  }


  async function deleteRecord(record_id) {
    try {
      // setLoading(true)
      const deleted_at = new Date()
      const deleted_by = userCredentials.email
      const body = {deleted_at, deleted_by}
      const res = await fetch(`${process.env.REACT_APP_API_URL}v_o/id/${record_id}/a=del`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
      }).then((response) => {
        // setLoading(false)
        console.log ("Record Deleted")
        window.location.reload(false)
      })
    } catch (err) {
      console.error(err.message);
    }
  }




  function handleDelete(e, record_id) {
    e.preventDefault()

    if(window.confirm('Are you sure you wish to delete record ID: ' + record_id + '?')){
      deleteRecord(record_id)
    }
  }



  const tableRow = {
    padding: '0.75rem',
    verticalAlign: 'middle',
    borderTop: '1px solix #dee2e6',
  }


  return (
    <section className="ps-my-account ps-page--account">
        <div className="row">
          <div className="col-lg-12">
            <div className="ps-page__content">

              <form className="ps-form--product-form" >
                <div className="ps-form__header">
                  <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <h3>All Variant Options</h3>

                      <div className="form-group submit" style={{marginTop: '-25px', marginBottom: '0px'}}>
                        <Link to="/admin/variant_options/new">
                          <button className="ps-btn" onClick={e => handleSubmit(e)}>Add New Variant Option</button>
                        </Link>
                      </div>
                    </div>
                </div>
                <div className="ps-form__content">

                  <div className="row">

                        <table class="table mt-5">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Product ID</th>
                              <th>Variant Type</th>
                              <th>Option Value</th>

                              <th>Date Modified</th>
                              <th>View</th>
                              <th>Edit</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>

                          {variant_options.map((variant_option) => (
                            <tr key={variant_option.id}>
                              <td style={tableRow}>{variant_option.id}</td>
                              <td style={tableRow}>
                                <Link to={`/admin/p/${variant_option.product_id}`}>
                                  <button className="ps-btn">{variant_option.product_name}</button>
                                </Link>
                              </td>
                              <td style={tableRow}>
                                <Link to={`/admin/v/${variant_option.variant_id}`}>
                                  <button className="ps-btn">{variant_option.variant_name}</button>
                                </Link>
                              </td>
                              <td style={tableRow}>{variant_option.name}</td>

                              <td style={tableRow}>{moment(variant_option.date_modified).format('lll') != 'Invalid date' ? moment(variant_option.date_modified).format('lll') : ''  }</td>
                              <td style={tableRow}>
                                <Link to={`/admin/variant_option/${variant_option.id}`}>
                                  <button className="ps-btn-delete">
                                      <i className='icon-eye'></i>
                                  </button>
                                </Link>
                              </td>
                              <td style={tableRow}>
                                <Link to={`/admin/variant_option/${variant_option.id}/edit`}>
                                  <button className="ps-btn-delete">
                                      <i className='icon-pencil'></i>
                                  </button>
                                </Link>
                              </td>
                              <td style={tableRow}>
                                <button className="ps-btn-delete" onClick={e => handleDelete(e, variant_option.id)}>
                                    <i className='icon-cross'></i>
                                </button>
                              </td>



                            </tr>
                          ))}
                          </tbody>
                        </table>

                      </div>
                    </div>


              </form>


          </div>
        </div>
      </div>
    <div style={{height: '5vh'}}/>




</section>

  );

}


export default ProductVariantOptionsTable;
